import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "weightIn",
    "weightOut",
    "weightInUnit",
    "weightOutUnit",
    "preview",
  ];
  static values = { template: String, unitConversions: Object };

  parseWeightValue(value) {
    if (value === null || value === undefined) {
      return NaN;
    }

    const rawValue = String(value).trim();
    if (rawValue.length === 0) {
      return NaN;
    }

    const hasComma = rawValue.includes(",");
    const hasDot = rawValue.includes(".");
    let normalizedValue = rawValue;

    if (hasComma && hasDot) {
      if (rawValue.lastIndexOf(",") > rawValue.lastIndexOf(".")) {
        normalizedValue = rawValue.replace(/\./g, "").replace(",", ".");
      } else {
        normalizedValue = rawValue.replace(/,/g, "");
      }
    } else if (hasComma) {
      normalizedValue = rawValue.replace(",", ".");
    }

    return Number.parseFloat(normalizedValue);
  }

  compute() {
    const weightIn = this.parseWeightValue(this.weightInTarget.value);
    const weightOut = this.parseWeightValue(this.weightOutTarget.value);

    if (!weightIn || !weightOut || weightIn === 0) {
      this.previewTarget.textContent = "";
      this.previewTarget.className = "mt-1 text-sm font-medium";
      return;
    }

    const unitIn = this.hasWeightInUnitTarget
      ? this.weightInUnitTarget.value
      : "kg";
    const unitOut = this.hasWeightOutUnitTarget
      ? this.weightOutUnitTarget.value
      : "kg";
    const unitConversions = this.unitConversionsValue || {};
    const unitInFactor = unitConversions[unitIn];
    const unitOutFactor = unitConversions[unitOut];

    if (!unitInFactor || !unitOutFactor) {
      this.previewTarget.textContent = "";
      this.previewTarget.className = "mt-1 text-sm font-medium";
      return;
    }

    const weightInBase = weightIn * unitInFactor;
    const weightOutBase = weightOut * unitOutFactor;
    const yieldPct = ((weightOutBase / weightInBase) * 100).toFixed(1);

    let colorClass = "text-success";
    if (yieldPct < 70) {
      colorClass = "text-error";
    } else if (yieldPct < 85) {
      colorClass = "text-warning";
    }

    const template = this.hasTemplateValue
      ? this.templateValue
      : "Yield: %{percentage}% (%{weight_out} %{unit_out} of %{weight_in} %{unit_in} input)";
    const message = template
      .replace("%{percentage}", yieldPct)
      .replace("%{weight_out}", weightOut)
      .replace("%{unit_out}", unitOut)
      .replace("%{weight_in}", weightIn)
      .replace("%{unit_in}", unitIn);

    this.previewTarget.textContent = message;
    this.previewTarget.className = `text-sm font-medium mt-1 ${colorClass}`;
  }
}
